<template>
  <h2 class="title">{{ screenTitle }}</h2>
</template>

<script>
export default {
  name: 'screen-title',
  props: {
    screenTitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/partials/ScreenTitle.vue